import React from 'react';

const Promo = ({ promoHeadline, promoCopy }) => {
  return (
		<div className="container promo-wrapper">
			<h1 className="promo-title">{promoHeadline}</h1>
			<p>{promoCopy}</p>
		</div>
	);
};

export default Promo;
